import { AttachmentType } from '@/constants/documents';
import { ALL_ROLES, STAKEHOLDER_ROLES_V2 } from '@/containers/withStakeholderLogic/constants';
import { ENTITY_TYPES, ORGANIZATION_ENTITY_TYPES } from 'moet-core/src/constants';

export const REGISTRATION_ID_OPTIONS = {
  DE: 'DE',
  FORCED: 'FORCED',
  OPTIONAL: 'OPTIONAL',
  DEFAULT: 'DEFAULT',
  TIN: 'TIN',
  UNAVAILABLE: 'UNAVAILABLE',
};

export const VAT_ID_OPTIONS = {
  FORCED: 'FORCED',
  OPTIONAL: 'OPTIONAL',
  DEFAULT: 'DEFAULT',
  UNAVAILABLE: 'UNAVAILABLE',
};

export const SOLE_TRADER_OPTIONS = {
  SOLE_PROPRIETORSHIP: 'SOLE_PROPRIETORSHIP',
  WITH_OPERATING_ADDRESS: 'WITH_OPERATING_ADDRESS',
  WITHOUT_OPERATING_ADDRESS: 'WITHOUT_OPERATING_ADDRESS',
};

export const DOCUMENT_TYPE = { ...AttachmentType };
export const DOCUMENT_TYPES = Object.values(DOCUMENT_TYPE);

export const OPTIONS_META = {
  VAT_ID_KIND: {
    OPTIONS: VAT_ID_OPTIONS,
    DESCRIPTION: 'Identifies which VAT ID container is going to run',
    OPTIONS_DESCRIPTIONS: {
      FORCED: 'VAT ID is mandatory',
      OPTIONAL: 'VAT ID is optional',
      DEFAULT: 'VAT ID is optional and has no validation of format',
      UNAVAILABLE: 'VAT is not collected',
    },
  },
  REGISTRATION_ID_KIND: {
    OPTIONS: REGISTRATION_ID_OPTIONS,
    DESCRIPTION: 'Identifies which Registration ID container is going to run',
    OPTIONS_DESCRIPTIONS: {
      DE:
        'Registration number optional and if present is collected together with registration authority',
      FORCED: 'Registration number is mandatory',
      OPTIONAL: 'Registration number is optional',
      DEFAULT: 'Registration number is optional and has no format validation',
      TIN: 'US Tax Identification Number is collected',
      UNAVAILABLE: 'No registration number collected',
    },
  },
  ALLOW_PUBLIC_ON_MANAGED: {
    OPTIONS: { true: true, false: false },
    DESCRIPTION: 'Indicates if we support public companies on the managed flows',
  },
  ALLOW_PUBLIC_ON_UNMANAGED: {
    OPTIONS: { true: true, false: false },
    DESCRIPTION: 'Indicates if we support public companies on the unmanaged flows',
  },
  SOLE_TRADER_KIND: {
    OPTIONS: SOLE_TRADER_OPTIONS,
    DESCRIPTION: 'Identifies which sole trader container is going to run',
    OPTIONS_DESCRIPTIONS: {
      SOLE_PROPRIETORSHIP: 'US Sole proprietorship data is collected',
      WITH_OPERATING_ADDRESS: 'Sole trader data is collected with operating address',
      WITHOUT_OPERATING_ADDRESS: 'Sole trader data is collected without operating address',
    },
  },
  COLLECT_OPERATING_ADDRESS_ON_COMPANY_DETAILS: {
    OPTIONS: { true: true, false: false },
    DESCRIPTION: 'Indicates if we collect operating address on the company details step',
  },
  COLLECT_COMPANY_DETAILS_ON_UNMANAGED: {
    OPTIONS: { true: true, false: false },
    DESCRIPTION: 'Indicates if we collect company details on registered unmanaged merchants',
  },
  ENRICHES_VAT: {
    OPTIONS: { true: true, false: false },
    DESCRIPTION: "Indicates if we don't collect VAT but we enrich it from another field",
  },
  DOCUMENTS: {
    BUSINESS: {
      ALL: {
        OPTIONS: DOCUMENT_TYPES,
        DESCRIPTION: 'Documents required for the all merchants in that country',
      },
      REGISTRATION: {
        true: {
          OPTIONS: DOCUMENT_TYPES,
          DESCRIPTION: 'Documents required for registered merchants',
        },
        false: {
          OPTIONS: DOCUMENT_TYPES,
          DESCRIPTION: 'Documents required for non-registered merchants',
        },
      },
      ENTITY_TYPE: {
        ...ENTITY_TYPES.reduce(
          (acc, entityType) => ({
            ...acc,
            [entityType]: {
              OPTIONS: DOCUMENT_TYPES,
              DESCRIPTION: `Documents required for ${entityType} entity type companies `,
            },
          }),
          {},
        ),
        ...ORGANIZATION_ENTITY_TYPES.reduce(
          (acc, orgEntityType) => ({
            ...acc,
            [orgEntityType]: {
              OPTIONS: DOCUMENT_TYPES,
              DESCRIPTION: `Documents required for ${orgEntityType} entity type companies `,
            },
          }),
          {},
        ),
      },
    },
    STAKEHOLDERS: {
      ALL: {
        OPTIONS: DOCUMENT_TYPES,
        DESCRIPTION: 'Documents required for all stakeholders',
      },
      ROLES: ALL_ROLES.reduce(
        (acc, role) => ({
          ...acc,
          [role]: {
            OPTIONS: DOCUMENT_TYPES,
            DESCRIPTION: `Documents required for ${role} role `,
          },
        }),
        [],
      ),
    },
  },
  ROLE_CONSTRAINTS: Object.values(STAKEHOLDER_ROLES_V2).reduce((acc, curr) => ({
    ...acc,
    [curr]: {
      min: {
        DESCRIPTION: 'Minimum amount of stakeholders of this type required',
      },
      max: {
        DESCRIPTION: 'Maximum amount of stakeholders of this type required',
      },
    },
  })),
};
